export default "__VITE_ASSET__BI2V0y0v__"